import theme from '@adsk/alloy-react-theme';

export const STYLES = {
  LoadMoreText: [
    theme.typography.bodySmall,
    {
      marginLeft: 13,
      color: theme.colors.charcoal700,
    },
  ],
  LoadMoreDataRow: { paddingLeft: '50px', justifyContent: 'flex-start' },
  TableContainer: {
    height: '100%',
    overflow: 'auto',
    width: '100%',
  },
  StickyHeader: { position: 'sticky', margin: 0, top: 0, zIndex: 1 },
  TableStyle: (width: number) => [
    {
      width,
      borderSpacing: 0,
      textAlign: 'left',
    },
  ],
  HeaderOverFlowText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
